<template>
    <div>
        <template
            v-for="(property, index) in properties"
        >
            <summary-value
                :key="index"
                class="py-3 px-4"
                :object="benefits"
                :property="property"
                :small="small"
                :greyed="isGreyed(property)"
                :inverted="isInverted(property)"
            ></summary-value>

            <v-divider
                class="mx-4"
            ></v-divider>
        </template>
    </div>
</template>

<script>
    import SummaryValue from './../../Global/SummaryValue';

    import KeyPlanMixin from "./../keyplan";

    export default {
        name: 'Key-Plan-Side-Menu-Attributes',

        mixins: [
            KeyPlanMixin
        ],

        components: {
            SummaryValue,
        },

        props: {
            'small': {
                type: Boolean,
                default: false,
            }
        },

        data() {
            return {
                properties: [
                    'keyplanMaxBenefit',
                    'keyplanPrincipalLiquidity',
                    'keyplanEstateProtection',
                    'keyplanEstateGapCover',
                    'keyplanSpouseLiquidity',
                    'keyplanChildLiquidity',
                    'keyplanPremium',
                    'keyplanTotalBenefits',
                ]
            }
        },

        methods: {
            isGreyed(property) {
                return property === 'keyplanPremium';
            },
            isInverted(property) {
                return property === 'keyplanTotalBenefits';
            }
        }
    }
</script>
